<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ManufacturerForm v-if="manufacturer" :manufacturer="manufacturer" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ManufacturerForm from '@/components/settings/stock-registers/manufacturer/ManufacturerForm.vue'

  export default {
    name: 'MaintanceReason',
    components: {
      PageTitle,
      PageRowWrapper,
      ManufacturerForm
    },
    computed: {
      ...mapState({
        manufacturer: state => state.manufacturer.manufacturerById
      })
    },
    methods: {
      ...mapActions('manufacturer', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
